import HourSpan from '@shared/models/hour_span';

export const numMobileCalendarDays = 3;
export const numDesktopCalendarDays = 7;
export const hourSpan = new HourSpan(8, 22);
